import { GetNameWithTranslation } from './Functions/GetNameWithTranslation';
import { ActuatorStateI } from './redux/types/app';

export const actuators: ActuatorStateI[] = [
    
    /*
        WIRELESS
    */
    // Lightning Switching
    {
        tech: 'wireless',
        type: 'RFSAI-61B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('1x 8A', 'channel'),
        refImg: 'RFSAI-61B-SL.png',
        icon: 'switching_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'switching',
        price: 65.34  
    },
    {
        tech: 'wireless',
        type: 'RFSAI-62B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('2x 8A', 'channels'),
        refImg: 'RFSAI-62B-SL.png',
        icon: 'switching_actuator_box',
        dinrail: false,
        numberOfChannels: 2,
        usage: 'switching',
        price: 68.48
    },
    {
        tech: 'wireless',
        type: 'RFSA-61MI',
        applianceType: 'lighting',
        name: GetNameWithTranslation('1x 16A', 'channel'),
        refImg: 'RFSA-61MI.png',
        icon: 'actuator_din_1',
        dinrail: true,
        numberOfChannels: 1,
        usage: 'switching',
        price: 58.37
    },
    {
        tech: 'wireless',
        type: 'RFSA-66MI',
        applianceType: 'lighting',
        name: GetNameWithTranslation('6x 8A', 'channels'),
        refImg: 'RFSA-66M.png',
        icon: 'actuator_din_3',
        dinrail: true,
        numberOfChannels: 6,
        usage: 'switching',
        price: 125.49
    },
    // Lightning Dimming
    {
        tech: 'wireless',
        type: 'RFDEL-71B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_300w_dimmer'),
        refImg: 'RFDEL-71B-SL.png',
        icon: 'phase_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'dimming',
        price: 75.12
    },
    {
        tech: 'wireless',
        type: 'RFDALI-04B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'dali_dimmer')} ${GetNameWithTranslation('4', 'channels')}`,
        refImg: 'RFDALI-04B-SL.png',
        icon: 'dali_actuator_box_4x',
        dinrail: false,
        numberOfChannels: 4,
        usage: 'dali-dimming',
        price: 94.80
    },
    {
        tech: 'wireless',
        type: 'RFDALI-32B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'dali_dimmer')} ${GetNameWithTranslation('32', 'channels')}`,
        refImg: 'RFDALI-32B-SL.png',
        icon: 'dali_actuator_box_32x',
        dinrail: false,
        numberOfChannels: 32,
        usage: 'dali-dimming',
        price: 150
    },
    {
        tech: 'wireless',
        type: 'RFDAC-71B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'analog_dimmer')}, 0-10V`,
        refImg: 'RFDAC-71B-SL.png',
        icon: 'phase_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'dimming',
        price: 76.66
    },
    {
        tech: 'wireless',
        type: 'RFDEL-71M',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_600w_dimmer'),
        refImg: 'RFDEL-71M.png',
        icon: 'phase_actuator_din_3',
        dinrail: true,
        numberOfChannels: 1,
        usage: 'dimming',
        price: 139.56
    },
    {
        tech: 'wireless',
        type: 'RFDEL-76M',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_6x150w_dimmer'),
        refImg: 'RFDEL-76M.png',
        icon: 'phase_actuator_din_6',
        dinrail: true,
        numberOfChannels: 6,
        usage: 'dimming',
        price: 376.75
    },
    {
        tech: 'wireless',
        type: 'RFDA-73M/RGB',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'rgb_dimmer', ', 4x'),
        refImg: 'RFDA-73M_RGB.png',
        icon: 'phase_actuator_din_3',
        dinrail: true,
        numberOfChannels: 4,
        usage: 'dimming',
        price: 111.49
    },

    // Curtains 
    {
        tech: 'wireless',
        type: 'RFJA-32B-SL',
        applianceType: 'curtains',
        name: GetNameWithTranslation('', 'curtain_actuator'),
        refImg: 'RFJA-32B-SL.png',
        icon: 'actuator_curtain_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'curtains',
        numberOfRequiredConnections: 2,
        price: 62.52
    },
    {
        tech: 'wireless',
        type: 'RFJA-52H/ISC',
        applianceType: 'curtains',
        name: GetNameWithTranslation('', 'curtain_actuator_slim'),
        refImg: 'RFJA-52H_ISC.png',
        icon: 'actuator_stas_stak_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'curtains',
        numberOfRequiredConnections: 2,
        //price: 0
    },

    // HVAC
    {
        tech: 'wireless',
        type: 'RFATV-2',
        applianceType: 'hvac',
        usage: 'hvac',
        name: GetNameWithTranslation('', 'rfatv-2'),
        refImg: 'RFATV-2.png',
        icon: 'rfatv',
        numberOfChannels: 1,
        maximumAppliancesPerChannel: 1,
        dinrail: false,
        price: 85.92
    }

];
export const switchingActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage === 'switching');
export const dimmingActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage?.includes('dimming'));
export const curtainActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage === 'curtains');
export const hvacActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.applianceType === 'hvac');